import { render, staticRenderFns } from "./CardMobileProfissional.vue?vue&type=template&id=1b01ea5c&scoped=true"
var script = {}
import style0 from "./CardMobileProfissional.vue?vue&type=style&index=0&id=1b01ea5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01ea5c",
  null
  
)

export default component.exports